<template>
  <div class="page-left-side-page">
    <div class="--left">
      <div class="api-left-navigation">
        <div class="api-left-navigation__title">{{ getLocalization('API') }}</div>
        <div class="api-left-navigation__items">
          <a href="#faq-table-countries" :class="{ 'active': showCountries }" @click="showCountries=true">{{getLocalization('List of countries')}}</a>
          <a href="#faq-table-services" :class="{ 'active': !showCountries }" @click="showCountries=false" data-section-slug="services-list">{{getLocalization('List of services')}}</a>
        </div>
      </div>
    </div>
    <div class="--right --small">
      <div>
        <div v-show="showCountries" class="--country-list mw-684">
          <div class="cms-block-stab">
            <h1>{{getLocalization('List of countries')}}</h1>
          </div>
          <div class="table-search-items">
            <div class="table-search-items__section">
              <label class="table-search-items__search">
                <input v-model="searchCountries" type="text" :placeholder="getLocalization('Search by country')"/>
                <img src="/img/svg/common/search-black.svg" alt=""/>
              </label>
              <div class="table-search-items__table">
                <table>
                  <thead>
                  <tr>
                    <td>{{getLocalization('Name')}}</td>
                    <td>ID</td>
                    <td>{{getLocalization('For API-partners')}}</td>
                    <td>{{getLocalization('Operators')}}</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(country, index) in searchCountriesList" :key="index">
                    <td>
                      <div class="d-flex align-items-center">
                        <img :src="country['img_path']" class="--img" alt=""/>
                        {{ getLocalization(country.title) }}
                      </div>
                    </td>
                    <td>{{ country['activate_org_code'] }}</td>
                    <td>{{country['alternative_params']['smshub_name']}}</td>
                    <td>{{country['operators'].map(item => item.name).join(', ')}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!showCountries" class="--services-list mw-684">
          <div class="cms-block-stab">
            <h1>{{getLocalization('List of services')}}</h1>
          </div>
          <div class="table-search-items">
            <div class="table-search-items__section">
              <label class="table-search-items__search">
                <input v-model="searchServices" type="text" :placeholder="getLocalization('Search by country')"/>
                <img src="/img/svg/common/search-black.svg" alt=""/>
              </label>
              <div class="table-search-items__table">
                <table>
                  <thead>
                  <tr>
                    <td>{{getLocalization('Name')}}</td>
                    <td>ID</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(service, index) in searchServicesList" :key="index">
                    <td>
                      <div class="d-flex align-items-center">
                        <img  style="border-radius: 7px" :src="service['img_path']" class="--img" alt=""/>
                        {{ getLocalization(service.title) }}
                      </div>
                    </td>
                    <td>{{ service['activate_org_code'].toUpperCase() }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "apiOther",
  props: [
    'countries',
    'services'
  ],
  created() {
    if (window.location.hash) {
      this.showCountries = false;
    }
  },
  mounted() {
    window.addEventListener('hashchange', this.checkAndRemoveHash);
    this.listCountries = this.prepareCountries(this.countries);
    this.listServices = this.services;
    this.totalCountries = this.listCountries.length;
    this.totalServices = this.listServices.length;
  },
  data() {
    return {
      showCountries: true,
      perPage: 15,
      totalCountries: 0,
      totalServices: 0,
      listCountries: [],
      listServices: [],
      searchCountries: '',
      searchServices: '',
    }
  },
  computed: {
    searchCountriesList() {
      if (!this.searchCountries) {
        return [...this.listCountries]
      }

      const searchCountries = (this.searchCountries || '').trim().toLowerCase();
      return this.listCountries.filter(country => country.alternative_title_locale && country.alternative_title_locale.toLowerCase().includes(searchCountries));
    },
    searchServicesList() {
      if (!this.searchServices) {
        return [...this.listServices]
      }

      const searchServices = (this.searchServices || '').trim().toLowerCase();
      return this.listServices.filter(service => service.title && service.title.toLowerCase().includes(searchServices));
    },
  },
  methods: {
    checkAndRemoveHash() {
      if (window.location.hash) {
        history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search
        );
      }
    },
    prepareCountries(array) {
      let result = [];
      array.map(el => {
        el.forEach(i => i.alternative_title_locale = this.getLocalization(i.title));
        result.push(...el);
      });
      return result;
    }
  }
}
</script>
